import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../environment";

const ENQUIRY_BASE_URL = API_BASE_PATH;

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

// ------------------
// Export Selected Enquiries PDF
// ------------------
export const exportSelectedEnquiriesPdf = async (
  enquiryIds: string[],
  _token: string | null
) => {
  try {
    if (enquiryIds.length === 0) {
      toast.warning("No enquiry IDs selected to export as PDF.");
      return;
    }

    const params = new URLSearchParams();
    enquiryIds.forEach((id) => {
      params.append("enquiry_id", id);
    });

    const response = await axios.get(
      `${ENQUIRY_BASE_URL}/enquiries/data/selected/download/pdf`,
      {
        headers: {
          accept: "application/json",
          authorization: "Bearer " + _token,
        },
        params,
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Selected_Enquiries.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("PDF downloaded successfully.");
  } catch (error) {
    const message = extractErrorMessage(error);
    console.error("Export PDF failed:", error);
    toast.error(`${message}`);
  }
};

// ------------------
// Export Selected Enquiries Excel
// ------------------
export const exportSelectedEnquiriesExcel = async (
  enquiryIds: string[],
  _token: string | null
) => {
  try {
    if (enquiryIds.length === 0) {
      toast.warning("No enquiry IDs selected to export as Excel.");
      return;
    }

    const params = new URLSearchParams();
    enquiryIds.forEach((id) => {
      params.append("enquiry_id", id);
    });

    const response = await axios.get(
      `${ENQUIRY_BASE_URL}/enquiries/data/selected/download/excel`,
      {
        headers: {
          accept: "application/json",
          authorization: "Bearer " + _token,
        },
        params,
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Selected_Enquiries.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("Excel downloaded successfully.");
  } catch (error) {
    const message = extractErrorMessage(error);
    console.error("Export Excel failed:", error);
    toast.error(`${message}`);
  }
};

// ------------------
// Export All Enquiries PDF
// ------------------
export const exportAllEnquiriesPdf = async (_token: string | null) => {
  try {
    const response = await axios.get(
      `${ENQUIRY_BASE_URL}/enquiriesdata/all/pdf`,
      {
        headers: {
          accept: "application/json",
          authorization: "Bearer " + _token,
        },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "All_Enquiries.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("All enquiries PDF downloaded successfully.");
  } catch (error) {
    const message = extractErrorMessage(error);
    console.error("Failed to export all enquiries as PDF:", error);
    toast.error(`${message}`);
  }
};

// ------------------
// Export All Enquiries Excel
// ------------------
export const exportAllEnquiriesExcel = async (_token: string | null) => {
  try {
    const response = await axios.get(
      `${ENQUIRY_BASE_URL}/enquiries/data/all/excel`,
      {
        headers: {
          accept: "application/json",
          authorization: "Bearer " + _token,
        },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "All_Enquiries.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("All enquiries Excel downloaded successfully.");
  } catch (error) {
    const message = extractErrorMessage(error);
    console.error("Failed to export all enquiries as Excel:", error);
    toast.error(`${message}`);
  }
};
